import { render, staticRenderFns } from "./MySupportTicketPreview.vue?vue&type=template&id=27a0b6ec"
import script from "./MySupportTicketPreview.vue?vue&type=script&lang=js"
export * from "./MySupportTicketPreview.vue?vue&type=script&lang=js"
import style0 from "./MySupportTicketPreview.vue?vue&type=style&index=0&id=27a0b6ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports